import Price from '~/utils/Price';

import { Error, ErrorCode } from './Error';
import { FinalCalculationProduct } from './FinalCalculationProduct';

export class FinalCalculation {
	currency: string | null;

	secondAndThirdLowestPriceAvg: Price | null;

	threeLowestPricesAvg: Price | null;

	deviation: number | null;

	emptyResultReason: Error[];

	fromProducts: FinalCalculationProduct[];

	constructor(
		currency: string | null,
		secondAndThirdLowestPriceAvg: Price | null,
		threeLowestPricesAvg: Price | null,
		deviation: number | null,
		emptyResultReason: Error[],
		fromProducts: FinalCalculationProduct[]
	) {
		this.currency = currency;
		this.secondAndThirdLowestPriceAvg = secondAndThirdLowestPriceAvg;
		this.threeLowestPricesAvg = threeLowestPricesAvg;
		this.deviation = deviation;
		this.emptyResultReason = emptyResultReason;
		this.fromProducts = fromProducts;
	}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((reason) => reason.code === ErrorCode.RequiredProductSettingsMissingErrorCode) !==
			undefined
		);
	}

	isReferenceCountryProductMissing(): boolean {
		return (
			this.emptyResultReason.find((reason) => reason.code === ErrorCode.ReferenceCountryProductMissingErrorCode) !==
			undefined
		);
	}

	findOnlyOneProductPerCountryErrorCode(): Error | null {
		return this.emptyResultReason.find((reason) => reason.code === ErrorCode.OnlyOneProductPerCountryErrorCode) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return (
			this.emptyResultReason.find((reason) => reason.code === ErrorCode.RequiresReferenceSettingsErrorCode) !==
			undefined
		);
	}

	isMissingThreeReferenceCountryProducts(): boolean {
		return (
			this.emptyResultReason.find(
				(reason) => reason.code === ErrorCode.MissingThreeReferenceCountryProductsErrorCode
			) !== undefined
		);
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return (
			this.emptyResultReason.find((reason) => reason.code === ErrorCode.IllegalPriceTypeSelectedErrorCode) !== undefined
		);
	}
}
